import * as React from 'react';
import { usePerformAction } from 'react-remote-data-hooks';
import api from '../../../../api';
import { SMSSettings } from '../../../../core';
import UpdateForm from './UpdateForm';

interface ISMSSettingsProps {
  data?: SMSSettings;
  reload?: () => void;
}

const SMSSettingsTab: React.FunctionComponent<ISMSSettingsProps> = (props) => {
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: SMSSettings) =>
      api.settings.updateSMSSettings({
        ...data,
        otpLength: Number(data.otpLength),
      }),
    () => {
      props.reload?.();
      setEditModalOpen(false);
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">SMS Settings</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Value
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Enabled</td>
                <td>{props.data?.sendSms ? 'Yes' : 'No'}</td>
              </tr>
              <tr>
                <td>Account ID</td>
                <td>{props.data?.account?.accountId}</td>
              </tr>
              <tr>
                <td>Sender ID</td>
                <td>{props.data?.account?.senderId}</td>
              </tr>
              <tr>
                <td>Username</td>
                <td>{props.data?.account?.username}</td>
              </tr>
              <tr>
                <td>Password</td>
                <td>{props.data?.account?.password && '*******'}</td>
              </tr>
              <tr>
                <td>Otp Length</td>
                <td>{props.data?.otpLength}</td>
              </tr>
              <tr>
                <td>Live OTP</td>
                <td>{props.data?.liveOtp ? 'Yes' : 'No'}</td>
              </tr>
              <tr>
                <td>Debug OTP</td>
                <td>{props.data?.debugOtp}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default SMSSettingsTab;
